import { useEffect, useRef } from "react";
import { useNotificationsStore } from "../stores/notificationsStore";

const DEFAULT_TITLE = "HelloSend";
const FAVICON_NORMAL = "/favicon.png";
const FAVICON_UNREAD = "/notification_favicon.ico";

const useTabTitle = () => {
  const unreadCount = useNotificationsStore((state) => state.unreadCount);
  const originalTitleRef = useRef(null);
  const faviconLinkRef = useRef(null);

  useEffect(() => {
    // Store the original title on first mount
    if (originalTitleRef.current === null) {
      originalTitleRef.current = document.title || DEFAULT_TITLE;
    }

    // Find or create favicon link element
    if (!faviconLinkRef.current) {
      faviconLinkRef.current = document.querySelector("link[rel='icon']");
      if (!faviconLinkRef.current) {
        faviconLinkRef.current = document.createElement("link");
        faviconLinkRef.current.rel = "icon";
        document.head.appendChild(faviconLinkRef.current);
      }
    }

    // Update the title and favicon based on unread count
    if (unreadCount > 0) {
      document.title = `(${unreadCount}) ${DEFAULT_TITLE}`;
      // Update favicon to unread version
      faviconLinkRef.current.href = FAVICON_UNREAD;
    } else {
      document.title = DEFAULT_TITLE;
      // Update favicon to normal version
      faviconLinkRef.current.href = FAVICON_NORMAL;
    }

    // Cleanup: restore original title and favicon on unmount
    return () => {
      if (originalTitleRef.current) {
        document.title = originalTitleRef.current;
      }
      if (faviconLinkRef.current) {
        faviconLinkRef.current.href = FAVICON_NORMAL;
      }
    };
  }, [unreadCount]);
};

export default useTabTitle;
